<template>
    <b-row>
        <b-col sm="3" md="2" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
            <div class="filter-wrapper">
                <b-form-select
                    v-model="category.selected"
                    :options="category.options"
                    @input="setParam" />
            </div>
        </b-col>
        <b-col sm="3" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
            <div class="filter-wrapper">
                <b-input-group prepend>
                    <b-form-input
                        placeholder="Search"
                        v-model="keyword"
                        @input="setParam">
                    </b-form-input>
                    <b-dropdown text="Advanced" variant="primary" slot="append">
                        <b-dropdown-item
                            v-for="(option, index) in advance_search_options"
                            :key="'advance_option_' + index"
                            @click="selectAdvanceOption(index)">
                            {{ option }}
                            <i class="ml-1" v-if="selected_advance_option === index">
                                <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                            </i>
                        </b-dropdown-item>
                    </b-dropdown>
                </b-input-group>
            </div>
        </b-col>
        <b-col></b-col>
        <!-- Start upload: BE moved to next sprint. Incomplete feature. -->
        <!-- <b-col sm="3" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
            <b-row no-gutters>
                <b-col sm="10">
                    <div class="upload-button action-button" @click="$refs.inputSimple.click()">
                        <img src="@/assets/images/excel-icon.png">
                        <span>Upload Simple Product</span>
                    </div>
                    <input
                        type="file"
                        @change="importSimple"
                        accept=".xlsx, .xls, .csv"
                        v-show="false"
                        id="importSimple"
                        ref="inputSimple"
                    />
                </b-col>
                <b-col sm="2">
                    <div class="download-button mx-2 mt-1">
                        <img class="action-button" src="@/assets/images/download-icon.png">
                    </div>
                </b-col>
            </b-row>
        </b-col>
        <b-col sm="3" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
            <b-row no-gutters>
                <b-col sm="10">
                    <div class="upload-button action-button" @click="$refs.inputSimple.click()">
                        <img src="@/assets/images/excel-icon.png">
                        <span>Upload Variable Product</span>
                    </div>
                    <input
                        type="file"
                        @change="importVariable"
                        accept=".xlsx, .xls, .csv"
                        v-show="false"
                        id="importVariable"
                        ref="inputVariable"
                    />
                </b-col>
                <b-col sm="2">
                    <div class="download-button mx-2 mt-1 action">
                        <img class="action-button" src="@/assets/images/download-icon.png">
                    </div>
                </b-col>
            </b-row>
        </b-col> -->
        <!-- End upload -->
        <b-col sm="2" md="2">
            <b-button
                variant="primary"
                class="d-inline-block new-button align-top"
                @click="showModal('new_product')">
                + Add New Product
            </b-button>
        </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "InventoryPageToolbar",
    data() {
        return {
            category: {
                selected: "all",
                options: [],
                initial_category: {
                    value: "all",
                    text: "All Categories"
                }
            },
            advance_search_options: [],
            selected_advance_option: "all",
            keyword: ""
        };
    },
    created: function() {
        this.getCategories();
        this.getAdvanceSearch();
    },
    computed: {
        ...mapState("dstoreInventories", [
            "categories",
            "advance_search",
            "param"
        ])
    },
    methods: {
        importSimple(e) {
            let file = e.target.files[0];
            console.log(file);
            // if (/\.(csv)$/i.test(file.name)) {
            //     this.$store.dispatch("branches/importCSV", file);
            // } else {
            //     notification.error(
            //         "Invalid file format, only CSV file is accepted."
            //     );
            // }
        },
        importVariable(e) {
            let file = e.target.files[0];
            console.log(file);
            // if (/\.(csv)$/i.test(file.name)) {
            //     this.$store.dispatch("branches/importCSV", file);
            // } else {
            //     notification.error(
            //         "Invalid file format, only CSV file is accepted."
            //     );
            // }
        },
        showModal: function(type) {
            this.$store.commit("dstoreInventories/setModal", {
                type: type,
                status: true
            });
            this.$store.commit("dstoreInventories/errors", null);
        },

        getCategories: async function() {
            // let _this = this;
            this.category.options = [];
            await this.$store
                .dispatch("dstoreInventories/getCategories")
                .then(() => {
                    this.category.options.push(this.category.initial_category);
                    // console.log(this.categories);
                    // console.log(ids);

                    this.categories
                        .map(category => {
                            return {
                                value: category.id,
                                text: category.name
                            };
                        })
                        .map(category => {
                            this.category.options.push(category);
                        });

                    // console.log(this.category.options);
                });
        },

        getAdvanceSearch: async function() {
            await this.$store
                .dispatch("dstoreInventories/getAdvanceSearch")
                .then(() => {
                    this.advance_search_options = this.advance_search;
                });
        },

        selectAdvanceOption: function(value) {
            this.selected_advance_option = value;
            if (this.keyword) this.setParam();
        },

        setParam: function() {
            let param = {
                page: this.param.page,
                payload: {
                    search: {
                        // paired_key: this.category.selected,
                        keyword: this.keyword
                    }
                }
            };
            if (this.selected_advance_option !== 'all') param.payload.search['column'] = this.selected_advance_option;

            this.$store.commit("dstoreInventories/setParam", param);
        }
    }
};
</script>
<style lang="scss" scoped>
.upload-button {
    background: white;
    width: 100%;
    font-size: 14px;
    padding: 9px;
    border-radius: 50px;
    img {
        padding: 0 10px;
    }
}
</style>
